import Vue from 'vue'
import Router from 'vue-router'
import Layout from '@/views/layout/index'


Vue.use(Router)
const applicationToolRouter =[
  {
    path: '/',
    component: Layout,
    name:'applicationTool',
    children: [
    {
      path: '/applicationTool-fgbzss',
      component: () => import('@/views/applicationTool/applicationTool-fgbzss'),//应用工具-法规标准搜索
      name: 'applicationTool-fgbzss',
      linkActiveClass:'active',
    },
    {
      path: '/applicationTool-fgbzss-new',
      component: () => import('@/views/applicationTool/applicationTool-fgbzss-new'),//应用工具-法规标准搜索-重构版
      name: 'applicationTool-fgbzss-new',
      linkActiveClass:'active',
    },
    {
    	path:'/applicationTool-xfsd',
    	component:()=>import('@/views/applicationTool/applicationTool-xfsd'),//应用工具-新法速递
      name:'applicationTool-xfsd',
      linkActiveClass:'active',
    },
    {
    	path:'/applicationTool-xfsd-new',
    	component:()=>import('@/views/applicationTool/applicationTool-xfsd-new'),//应用工具-新法速递-重构版
      name:'applicationTool-xfsd-new',
      linkActiveClass:'active',
    },
    {
    	path:'/applicationTool-zxsx',
    	component:()=>import('@/views/applicationTool/applicationTool-zxsx'),//应用工具-最新失效
      name:'applicationTool-zxsx',
      linkActiveClass:'active',
    },
    {
    	path:'/applicationTool-zxsx-new',
    	component:()=>import('@/views/applicationTool/applicationTool-zxsx-new'),//应用工具-最新失效-重构版
      name:'applicationTool-zxsx-new',
      linkActiveClass:'active',
    },
    {
      path:'/applicationTool-grzx',
    	component:()=>import('@/views/applicationTool/applicationTool-grzx'),//应用工具-个人中心
      name:'applicationTool-grzx',
      redirect:'/applicationTool-grzx/applicationTool-readyDown',
      meta:{
        requireAuth:true
      },
      children:[
        {
          path:'/applicationTool-grzx/applicationTool-readyDown',  //已下载
          component: () => import('@/views/applicationTool/applicationTool-grzx/applicationTool-readyDown'),
          name:'applicationTool-readyDown',
          linkActiveClass:'active',
          meta:{
            requireAuth:true
          }
        },
        {
          path:'/applicationTool-grzx/applicationTool-readyCellect',  //已收藏
          component: () => import('@/views/applicationTool/applicationTool-grzx/applicationTool-readyCellect'),
          name:'applicationTool-readyCellect',
          linkActiveClass:'active',
          meta:{
            requireAuth:true
          }
        },
        {
          path:'/applicationTool-grzx/applicationTool-onlineNote',  //在线笔记
          component: () => import('@/views/applicationTool/applicationTool-grzx/applicationTool-onlineNote'),
          name:'applicationTool-onlineNote',
          linkActiveClass:'active',
          meta:{
            requireAuth:true
          }
        },
        {
          path:'/applicationTool-grzx/applicationTool-message',  //消息
          component: () => import('@/views/applicationTool/applicationTool-grzx/applicationTool-message'),
          name:'applicationTool-message',
          linkActiveClass:'active',
          meta:{
            requireAuth:true
          }
        },
      ]
    },
    {
      path:'/applicationTool-detail',  //消息 做笔记
      component: () => import('@/views/applicationTool/applicationTool-detail'),
      name:'applicationTool-detail',
    },
    {
      path:'/applicationTool-reader',  //消息 分享
      component: () => import('@/views/applicationTool/applicationTool-reader'),
      name:'applicationTool-reader',
    },
    {
      path:'/applicationTool-tjjg',//体检结果下发
      component: () => import('@/views/applicationTool/applicationTool-tjjg'),
      name:'applicationTool-tjjg',
      meta:{
        requireAuth:false
      }
    },
    {
      path:'/applicationTool-tjjgfsts', //体检结果发送提示
      component: () => import('@/views/applicationTool/applicationTool-tjjgfsts'),
      name:'applicationTool-tjjgfsts',
    },
    {
      path:'/applicationTool-zsgj',       //噪声工具计算
      component: () => import('@/views/applicationTool/applicationTool-zsgj'),
      name:'applicationTool-zsgj',
    },
    // {
    //   path:'/applicationTool-fxcx',       //风向查询系统
    //   component: () => import('@/views/applicationTool/applicationTool-fxcx'),
    //   name:'applicationTool-fxcx',
    // },
    {
      path:'/applicationTool-zsbk',       //健康知识百科
      component: () => import('@/views/applicationTool/applicationTool-zsbk'),
      name:'applicationTool-zsbk',
    },
    {
      path:'/applicationTool-zsbk-xq',       //健康知识百科
      component: () => import('@/views/applicationTool/applicationTool-zsbk-xq'),
      name:'applicationTool-zsbk-xq',
    },
    {
      path:'/applicationTool-whysxzcx',       //危害因素限值查询-化学有害因素 
      component: () => import('@/views/applicationTool/applicationTool-whysxzcx'),
      name:'applicationTool-whysxzcx',
    },
    {
      path:'/applicationTool-whysxzcx-other',       //危害因素限值查询-其它有害因素 
      component: () => import('@/views/applicationTool/applicationTool-whysxzcx-other'),
      name:'applicationTool-whysxzcx-other',
    },
    {
      path:'/applicationTool-PCUIquery',       //体检项目查询 
      component: () => import('@/views/applicationTool/applicationTool-PCUIquery'),
      name:'applicationTool-PCUIquery',
    },
    {
      path:'/applicationTool-hxfh',       //防护用品查询-呼吸防护
      component: () => import('@/views/applicationTool/applicationTool-hxfh'),
      name:'applicationTool-hxfh',
    },
    {
      path:'/applicationTool-tlfh',        //防护用品查询-听力防护
      component: () => import('@/views/applicationTool/applicationTool-tlfh'),
      name:'applicationTool-tlfh',
    },
    {
      path:'/applicationTool-dxgwfh',        //防护用品查询-典型岗位防护
      component: () => import('@/views/applicationTool/applicationTool-dxgwfh'),
      name:'applicationTool-dxgwfh',
    },

     {
      path:'/applicationTool-jsbz',       //警示标治查询
      component: () => import('@/views/applicationTool/applicationTool-jsbz'),
      name:'applicationTool-jsbz',
    },
    {
      path:'/applicationTool-jsbz-check',       //警示标治查询常见要求
      component: () => import('@/views/applicationTool/applicationTool-jsbz-check'),
      name:'applicationTool-jsbz-check',
    },

    {
      path:'/applicationTool-hxlb',       //化学类别查询
      component: () => import('@/views/applicationTool/applicationTool-hxlb'),
      name:'applicationTool-hxlb',
    },
    {
      path:'/applicationTool-demo',       //化学类别查询
      component: () => import('@/views/applicationTool/demo'),
      name:'applicationTool-demo',
    },

    ]

	}
]
export default applicationToolRouter



// WEBPACK FOOTER //
// ./src/router/applicationTool.js